{
  "BASE_URL": "https://api.shiftclockai.com/",
  "APPLICATION_BASEURL": "https://api.shiftclockai.com/"
}
